export default {
  title: 'Datenlöschung für {{name}} beantragen',
  description:
    'Damit wird ein DSGVO-Antrag auf Datenlöschung erstellt. Ein Admin muss ihn genehmigen, bevor die Daten des Kunden endgültig gelöscht werden.',
  form: {
    note: {
      label: 'Notiz',
      placeholder: 'Kontext für diesen Antrag hinzufügen (optional)',
    },
  },
  buttons: {
    confirm: 'Löschung beantragen',
  },
  toasts: {
    success: 'Antrag auf Datenlöschung erstellt',
    error: 'Antrag auf Datenlöschung konnte nicht erstellt werden',
  },
};
